import { QueryClient } from '@tanstack/react-query';

import { FAVORITES_QUERY_KEY } from '../queries';

const QUERY_CLIENT_OPTIONS = {
    defaultOptions: {
        queries: {
            retry: 0,
            gcTime: 24 * 60 * 60 * 1000,
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        },
    },
} as const;

let _browserQueryClient: QueryClient | undefined;

/**
 * Returns a QueryClient safe for both server and client use.
 * On the server: always returns a new instance to prevent cross-request cache leakage.
 * In the browser: returns a stable singleton so the cache persists across renders.
 */
export function getQueryClient(): QueryClient {
    if (typeof globalThis.window === 'undefined') {
        return new QueryClient(QUERY_CLIENT_OPTIONS);
    }
    _browserQueryClient ??= new QueryClient(QUERY_CLIENT_OPTIONS);
    return _browserQueryClient;
}

export function clearLogoutQueries(queryClient?: QueryClient): void {
    const client = queryClient ?? getQueryClient();
    client.removeQueries({ queryKey: [FAVORITES_QUERY_KEY] });
}
